<main>
  <div class="main-background position-absolute bg-cover w-100 z--1 bg-center"></div>
  <section class="container d-flex flex-column">
    <div class="row align-items-center justify-content-center g-0 min-vh-100">
      <div class="mt mt-13 text-center"><span class="it-quiz-text f-col fw-bold fs-50px-lh-63px">
        IT&nbsp;<span class="font-outfit col-purple fw-bold fs-50px-lh-63px">Q</span>uiz</span></div>
      <div class="card shadow custom-size col-white mx-auto mb-6 mt-6 h-auto rounded-3 position-relative">
        <div class="card-body p-8 p-30px-24px-40px">
            <div class="mb-3">
              <div class="w-100 text-align-center">
                <span class="sign-in-text f-col fw-bold">Sign In</span><br>
                <h5 class="d-inline col-grey f-col fw-normal text-center">Don’t have an account?
                  <a href="/signup" class="ms-1">Sign Up</a></h5>
              </div>
            </div>
            <br>
            <form [formGroup]="loginForm" (ngSubmit)="submit()">
              <div class="mb-3">
                <label for="email" class="label-focused form-label"
                       [ngClass]="{
                       'validation': isEmailBlurred && (email?.touched && email?.invalid)}">
                  <h5 class="d-inline ls-01em f-col fw-normal">{{ EMAIL_LABEL }}</h5></label>
                <div class="w-483px rounded-3 border-focused" [ngClass]="{
                       'border-validation': isEmailBlurred && (email?.touched && email?.invalid)}">
                <input formControlName="email"  type="email" id="email"
                       class="media-screen-w form-control-div w-100 pt-3 pb-3 pe-3 ps-3 border-0 font-outfit g-1 rounded-3" name="email" placeholder="Email address" autocomplete="username"
                       [(ngModel)]="admin.email"
                       (focus)="onFocus(EMAIL)"
                       (blur)="onBlur(EMAIL)">
                </div>
                <div *ngIf="isEmailBlurred && email?.errors?.['required']">
                  <div class="validation ps-2 pt-1 fs-12px-lh-15px font-outfit d-flex fw-normal ls-01em g-1" *ngIf='email?.touched && email?.invalid'>Email address is Required</div>
                </div>
                <div *ngIf="isEmailBlurred && email?.errors?.['email']">
                  <div class="validation ps-2 pt-1 fs-12px-lh-15px font-outfit d-flex fw-normal ls-01em g-1" *ngIf='email?.touched && email?.invalid'>This email address is invalid</div>
                </div>
              </div>
              <div class="password-div">
              <label for="password" class="label-focused form-label"
                     [ngClass]="{
                     'validation': isPasswordBlurred && password?.errors?.['required']}">
                <h5 class="d-inline ls-01em f-col fw-normal">{{ PASSWORD_LABEL }}</h5>
              </label>
              <div class="position-relative">
                <div class="w-483px rounded-3 border-focused"
                     [ngClass]="{
                       'border-validation': isPasswordBlurred && password?.errors?.['required']}">
                <input formControlName="password" [type]="passwordFieldType" id="password"
                       class="media-screen-w form-control-div w-100 pt-3 pb-3 pe-3 ps-3 border-0 font-outfit g-1 rounded-3" placeholder="Enter your password"
                       autocomplete="new-password"
                       (focus)="onFocus(PASSWORD)"
                       (blur)="onBlur(PASSWORD)">
                </div>
                <h3 class="password-toggle-icon cursor-pointer position-absolute">
                    <i [class]="passwordFieldType === PASSWORD ? 'far fa-eye-slash' : 'far fa-eye'"
                       (click)="togglePasswordVisibility()" class="password-icon-style"></i>
                </h3>
              </div>
              </div>
              <div *ngIf="isPasswordBlurred && password?.errors?.['required']">
                <div class="validation err-msg font-outfit d-flex fw-normal ls-01em g-1" *ngIf='password?.touched && password?.invalid'>Password is Required</div>
              </div>
              <br>
              <div class="d-flex justify-content-between align-items-center mb-4">
                <div class="form-check d-inline-block">
                  <input type="checkbox" formControlName="rememberMe" name="rememberMe" class="form-check-input checkbox-custom" id="rememberme">
                  <label class="form-check-label text-center remember-me" for="rememberme"><h5 class="d-inline fw-normal f-col ls-01em">Remember&nbsp;me</h5></label>
                </div>
                <div class="d-inline-block">
                  <a routerLink="/forgot/password" class="ms-70px fw-normal font-outfit"><h5 class="col-purple">Forgot password?</h5></a>
                </div>
              </div>
              <div *ngIf="!isAuthenticated" class="wrong-cred-div mt-6 d-flex w-100 pt-3 pb-3 pe-3 ps-3 rounded-3">
                <div class="cancel-div d-inline-block position-relative">
                  <img src="/assets/images/error/cancel.png" alt="cancel" class="cancel-img d-inline-block position-absolute">
                </div>
                <h3 class="m-0 ps-4 f-col fw-medium ls-01em">Wrong email or password</h3>
              </div>
              <div class="mt-6">
                <button type="submit" class="media-screen-w bg-purple py-2 rounded-4 w-100 g-1 border-0 d-flex align-items-center justify-content-center box-sizing-border-box"
                        [disabled]="loginForm.invalid"><h3 class="m-0 font-outfit col-white text-center fw-medium">Sign In</h3></button>
              </div>
              <div class="mt-6 align-items-center d-flex">
                <hr class="hr-line mt-0 mb-0 ms-2 me-3 flex-fill">
                <span class="f-col">or</span>
                <hr class="hr-line mt-0 mb-0 ms-2 me-3 flex-fill">
              </div>
              <div class="mt-6">
                <button (click)="loginWithGoogle()" class="media-screen-w bg-white f-col py-2 rounded-4 w-100 g-1 d-flex align-items-center justify-content-center box-sizing-border-box b-1">
                  <img src="/assets/images/brand/google-icon.png" alt="google-icon" class="h-20px">
                  <h3 class="m-0 f-col text-center fw-medium">
                      Continue with Google
                  </h3>
                </button>
              </div>
              <p *ngIf="isGoogleLoginError" class="text-danger text-center">Google login failed. Please try again.</p>
            </form>
          </div>
        </div>
      </div>
  </section>
</main>
